if (!localStorage.getItem("deviceName"))
  localStorage.setItem("deviceName", "{}");

function getDeviceName(uid) {
  var deviceName = JSON.parse(localStorage.getItem("deviceName"));      
  return deviceName[uid];  
}

function setDeviceName(uid, name) {
  var deviceName = JSON.parse(localStorage.getItem("deviceName"));
  deviceName[uid] = name;
  localStorage.setItem("deviceName", JSON.stringify(deviceName));
}

export {getDeviceName, setDeviceName};